export function distanceBetween(a: XY, b: XY) {
	const dx = a[0] - b[0];
	const dy = a[1] - b[1];

	const res = Math.sqrt(dx * dx + dy * dy);

	return res;
}
